export default [{
    name: '1 квартал',
    key: 'first',
    numberValue: 1,
    startMonth: 0,
}, {
    name: '2 квартал',
    key: 'second',
    numberValue: 2,
    startMonth: 3,
}, {
    name: '3 квартал',
    key: 'third',
    numberValue: 3,
    startMonth: 6,
}, {
    name: '4 квартал',
    key: 'fourth',
    numberValue: 4,
    startMonth: 9,
}];
